import { put, select } from 'redux-saga/effects';
import { photoCaptureIntelligentErrorLogFailureAction, photoCaptureIntelligentErrorLogRequestAction } from '../actions';
import { buildIntelligentPhotoCaptureFailureErrorLogRequest, getErrorMessagesBasedOnStatusCode } from '../utilities';
import { getInstanceReferenceId, getPhotoCaptureClaimNumber, getPhotoCaptureCompanyCode } from '../selectors';
export function* intelligentPhotoCaptureFailureLoggingSaga({ actionType, response, requestedPayload, claimNumber, requestedHttpMethod, companyCode, instanceReferenceId, errorDetail }) {
    try {
        const resolvedCompanyCode = companyCode || (yield select(getPhotoCaptureCompanyCode));
        const resolvedClaimNumber = claimNumber || (yield select(getPhotoCaptureClaimNumber));
        const resolvedInstanceReferenceId = instanceReferenceId || (yield select(getInstanceReferenceId));
        const errorLogRequest = buildIntelligentPhotoCaptureFailureErrorLogRequest({
            instanceReferenceId: resolvedInstanceReferenceId,
            actionType,
            claimNumber: resolvedClaimNumber,
            requestedHttpMethod,
            errorDetail: errorDetail,
            requestedPayload,
            response
        });
        yield put(photoCaptureIntelligentErrorLogRequestAction(resolvedCompanyCode, errorLogRequest, resolvedInstanceReferenceId));
    }
    catch (error) {
        const errorMessage = getErrorMessagesBasedOnStatusCode(error);
        yield put(photoCaptureIntelligentErrorLogFailureAction(errorMessage));
    }
}
//# sourceMappingURL=intelligentPhotoCaptureFailureLoggingSaga.js.map